<template>
  <div id="app">
    <hello :msg="msg"></hello>
    <display></display>
    <increase></increase>
  </div>
</template>

<script>
import Hello from './components/Hello.vue';
import Display from './components/Display.vue';
import Increase from './components/Increase.vue';
import Store from './vuex/store.js';

export default {
  props: ['msg'],
  components: {
    Hello,
    Display,
    Increase,
  },
  store: Store,
  data() {
    return {
    };
  },
};
</script>

<style>
html {
  height: 100%;
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

#app {
  color: #2c3e50;
  margin-top: -100px;
  max-width: 600px;
  font-family: Source Sans Pro, Helvetica, sans-serif;
  text-align: center;
}

#app a {
  color: #42b983;
  text-decoration: none;
}

.logo {
  width: 100px;
  height: 100px
}
</style>



/** WEBPACK FOOTER **
 ** App.vue?20e35d94
 **/